import { useQuery } from '@tanstack/react-query';

import { Declaration } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useDeclaration = (id: string) =>
  useQuery({
    queryKey: ['declaration', id],
    queryFn: async (): Promise<Declaration> => {
      try {
        if (id) {
          const { data } = await request({
            path: `declarations/${id}`,
            method: 'GET',
            authenticate: true,
          });

          return data;
        }
      } catch (error) {
        showErrorToast(error, 'Failed to fetch declaration details');
      }
    },
    enabled: !!id,
  });
